//---------------------
// calc rolled maximum
//---------------------
export default function calcRolledMax(parm) {
  // console.log('----------------------')
  // console.log('IN calcRolledMax')

  const max = Number(parm.max) || 0;
  const integs_tot = Number(parm.integs_tot) || 0;
  const improvs_tot = Number(parm.improvs_tot) || 0;

  let result;
  if (integs_tot) {
    result = max - integs_tot - improvs_tot
  } else {
    result = max - improvs_tot
  }
  // console.log("calcRolledMax MAX = ", result)
  return result;
}